/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// import axios from '../../http/axios/index.js'

export default {
  GET_CALENDARIO(state, payload) {
    state.calendarios = payload;
  },
  GET_HORARIO(state, payload) {
    state.horario = payload;
  },
  RESERVA_EXISTE(state, payload) {
    state.reserva_existe = payload;
  },
  GET_ID_AFOROXDIA_SELECCIONADO(state, payload) {
    state.id_aforoxdia = payload;
  },
  SET_LOADING2(state, payload) {
    state.loading2 = payload;
  },
  GET_ID_SELECCIONADO_OLD(state, payload) {
    state.id_old = payload;
  },
  GET_ID_SELECCIONADO(state, payload) {
    state.id = payload;
  },
  GET_DIA_DETALLE(state, payload) {
    state.dia_detalle = payload;
  },
  GET_ESTACION(state, payload) {
    state.estacion = payload;
  },
  GET_AFOROXDIA(state, payload) {
    state.aforoxdia = payload;
  },
  GET_AFOROXHORA(state, payload) {
    state.aforoxhora = payload;
  },
  GET_PEDIDO(state, payload) {
    state.pedido = payload;
    state.loading = true;
  },
  GET_FECHA_SELECCIONADO(state, payload) {
    state.fechaSeleccionada = payload;
    state.isVisibleDetalle = true;
  },
  GET_DIA_SELECCIONADO(state, payload) {
    state.diaSeleccionado = payload;
  },
  GET_HORA_SELECCIONADO(state, payload) {
    state.horaSeleccionado = payload;
  },
  GET_ID_HORA_SELECCIONADO(state, payload) {
    state.id_hora = payload;
  },

  UPDATE_CALENDARIO(state, payload) {
    state.calendarios.push(payload);
  }
  // SET_BEARER (state, accessToken) {
  //   axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
  // }
};
